import React from 'react';
import styled from '@emotion/styled';
import Table, { TableTitleDiv, TableStatDiv } from './Table';
import { ssColorCyan } from '../constants/style-constants';
import tableDataType from '../proptypes/table-data';

const RoleNameHeading = styled.a`
  color: ${ssColorCyan};
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const SpyRoleTable = ({ data }) => (
  <Table
    data={data}
    customCellRender={(cell, colTitle, cellIndex) => {
      if (cell.type !== 'role-match') return undefined;

      return (
        <td key={`cell-${cellIndex}`}>
          <TableTitleDiv>{colTitle}</TableTitleDiv>
          <TableStatDiv>
            <RoleNameHeading
              href={cell.path}
            >
              {cell.role}
            </RoleNameHeading>
            <div>{cell.description}</div>
          </TableStatDiv>
        </td>
      );
    }}
  />
);

SpyRoleTable.propTypes = {
  data: tableDataType.isRequired,
};

export default SpyRoleTable;
